import Swal from "sweetalert2";
import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY

export const getUnitsPromotion = (setStatus) => {

    api.get(`${urlApi}/sumaTravel/getUnitsPromotion`).then((res) => {
        setStatus(res.data)
    })
        .catch((error) => {
            console.log("error", error);

        })


}
export const getUnitsWhithPromo = async () => {

    const res = await api.get(`${urlApi}/sumaTravel/getUnitsWhithPromo`)
    return res.data


}

export const sendDataForm = async (formData, setIdPromocion) => {
    try {
        Swal.fire({
            title: 'Cargando...',
            html: 'Por favor, espera mientras procesamos tu solicitud.',
            allowOutsideClick: false, // Evita que se cierre al hacer clic fuera
            allowEscapeKey: false,   // Evita que se cierre con la tecla Escape
            didOpen: () => {
                Swal.showLoading(); // Muestra el spinner de carga
            }
        });

        const res = await api.post(`${urlApi}/sumaTravel/updateUnitPromotion`, formData);
        return res.data.ID_PROMOCION; // <-- ahora sí retorna a quien llame la función
    } catch (error) {
        Swal.close();
        console.log("error", error);
        throw error; // opcional, para manejarlo en el caller
    }
};
export const updateImages = async (data, nuevoIdPromocion, setUpdateTable, updateTable) => {

    const formadata = new FormData()
    formadata.append('ID', nuevoIdPromocion)
    Object.keys(data).forEach(key => {
        if (data[key]) {
            formadata.append(key, data[key]);
        }
    });

    await api.post(`${urlApi}/sumaTravel/updateUnitPromotionImagenes`, formadata).then((res) => {
        setUpdateTable(!updateTable)
        Swal.close();
    })
        .catch((error) => {
            console.log("error", error);
            Swal.close();

        })


}
export const updateUnitsWhithPromo = async (data, setUpdateTable, updateTable) => {

    await api.patch(`${urlApi}/sumaTravel/updateUnitsWhithPromo`, data).then((res) => {
        setUpdateTable(!updateTable)
        Swal.close();
    })
        .catch((error) => {
            console.log("error", error);
            Swal.close();

        })


}
export const getDataPromo = async (id_promo, setForm, setImages) => {
    Swal.fire({
        title: 'Cargando...',
        html: 'Por favor, espera mientras procesamos tu solicitud.',
        allowOutsideClick: false, // Evita que se cierre al hacer clic fuera
        allowEscapeKey: false,   // Evita que se cierre con la tecla Escape
        didOpen: () => {
            Swal.showLoading(); // Muestra el spinner de carga
        }
    });
    await api.get(`${urlApi}/sumaTravel/getDataPromo?id=${id_promo}`).then((res) => {
        Swal.close();
        const pathImages = process.env.REACT_APP_LANDING_IMAGES
        setForm(
            {
                ID_PROMO: id_promo,
                PROMO: res.data.PROMO,
                TITULO_BANNER: res.data.TITULO_BANNER,
                SUBTITULO_BANER: res.data.SUBTITULO_BANER,
                TITULO_INFORMACION: res.data.TITULO_INFORMACION,
                TEXTO_INFORMACION: res.data.TEXTO_INFORMACION,
                TITULO_SECCION_IMAGENES: res.data.TITULO_SECCION_IMAGENES,
                NUMERO_COTIZACION:res.data.NUMERO_COTIZACION,
                CONTENIDO_SECCION_IMAGENES: res.data.CONTENIDO_SECCION_IMAGENES,
                TITULO_CARD1: res.data.TITULO_CARD1,
                CONTENIDO_CARD1: res.data.CONTENIDO_CARD1,
                TITULO_CARD2: res.data.TITULO_CARD2,
                CONTENIDO_CARD2: res.data.CONTENIDO_CARD2,
                TITULO_CARD3: res.data.TITULO_CARD3,
                CONTENIDO_CARD3: res.data.CONTENIDO_CARD3,
                ACTIVO: res.data.ACTIVO,
            }

        )
        setImages({
            IMAGEN_BANER: res.data.IMAGEN_BANER ? `${pathImages}${res.data.IMAGEN_BANER}` : null,
            IMAGEN1: res.data.IMAGEN1 ? `${pathImages}${res.data.IMAGEN1}` : null,
            IMAGEN2: res.data.IMAGEN2 ? `${pathImages}${res.data.IMAGEN2}` : null,
            IMAGEN3: res.data.IMAGEN3 ? `${pathImages}${res.data.IMAGEN3}` : null,
            IMAGEN4: res.data.IMAGEN4 ? `${pathImages}${res.data.IMAGEN4}` : null,
            IMAGEN_CARD_1: res.data.IMAGEN_CARD_1 ? `${pathImages}${res.data.IMAGEN_CARD_1}` : null,
            IMAGEN_CARD_2: res.data.IMAGEN_CARD_2 ? `${pathImages}${res.data.IMAGEN_CARD_2}` : null,
            IMAGEN_CARD_3: res.data.IMAGEN_CARD_3 ? `${pathImages}${res.data.IMAGEN_CARD_3}` : null
        })
    })
        .catch((error) => {
            console.log("error", error);

        })


}
export const updateFormPromotion = async (data, setUpdateTable, updateTable) => {
    
    const formadata = new FormData()
    Object.keys(data.campos).forEach(key => {
        if (data.campos[key]) {
            formadata.append(key, data.campos[key]);
        }
    });

    Object.keys(data.images).forEach(key => {        
        if (data.images[key] == null) {
            formadata.append(key, 'DELETE');
        }
    });
    Object.keys(data.images).forEach(key => {
        if (typeof data.images[key] != 'string' && data.images[key] != null) {
            formadata.append(key, data.images[key]);
        }
    });
    Swal.fire({
        title: 'Cargando...',
        html: 'Por favor, espera mientras procesamos tu solicitud.',
        allowOutsideClick: false, // Evita que se cierre al hacer clic fuera
        allowEscapeKey: false,   // Evita que se cierre con la tecla Escape
        didOpen: () => {
            Swal.showLoading(); // Muestra el spinner de carga
        }
    });
    try {
        const res = await api.put(`${urlApi}/sumaTravel/updateFormPromotion`, formadata)
        Swal.close();
        setUpdateTable(!updateTable)
        return res.data;
    } catch (error) {
        console.log("error", error);
        Swal.close();
        throw error;
    }


}
